// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import styled from "styled-components";

const DeleteButtonContainer = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
`;

import {
  constructStripeNegativeBalanceButton,
  constructIsErrorButton,
  constructConfirmDeletionBtn,
} from "./modalMessage";

function StripeAccountDeletionModalFooter({
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'pageLoading' implicitly has an 'any' type.
  pageLoading,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'balance' implicitly has an 'any' type.
  balance,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'isError' implicitly has an 'any' type.
  isError,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'loading' implicitly has an 'any' type.
  loading,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'showDeleteButton' implicitly has an 'any' type.
  showDeleteButton,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'onCancel' implicitly has an 'any' type.
  onCancel,
  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'onConfirmDeletion' implicitly has an 'any' type.
  onConfirmDeletion,
}) {
  const [message, setMessage] = useState(constructConfirmDeletionBtn(loading, onConfirmDeletion));
  const isStripeBalanceNegative = balance.actualBalance < 0;
  useEffect(() => {
    if (isStripeBalanceNegative) {
      setMessage(constructStripeNegativeBalanceButton(showDeleteButton, onCancel));
    } else if (isError) {
      setMessage(constructIsErrorButton(showDeleteButton, onCancel));
    } else {
      setMessage(constructConfirmDeletionBtn(loading, onConfirmDeletion));
    }
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [balance, isError, loading]);

  return <DeleteButtonContainer>{pageLoading ? <Spin /> : message}</DeleteButtonContainer>;
}
export { StripeAccountDeletionModalFooter };
